/*
ORGANIZATION-SCALES
Define risks params for the whole organisations (attributes and scales)
*/
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { useState } from "react"
import organizationStore from "../model/organization.store"
import RiskOrganizationScalesConfig from "@/features/risks/entities/risk/ui/RiskOrganizationScalesConfig"
import RiskOrganizationAttributesConfig from "@/features/risks/entities/risk/ui/modals/RiskOrganizationAttributesConfig"
// import RiskOrganizationRpsImportConfig from "@/features/risks/entities/risk/ui/RiskOrganizationRpsImportConfig"
import SaveToast from "@/components/SaveToast"
import { StatusType } from "@/redux/_status.types"
import PageHeader from "@/components/page-header"
import { t } from "i18next"

export default function OrganizationScales() {
  const dispatch = useAppDispatch()
  const status = useAppSelector(organizationStore.selectors.status)

  const [isDirty, setIsDirty] = useState(false)

  const handleCancel = () => {
    dispatch(organizationStore.actions.cancel())
    setIsDirty(false)
  }

  const handleSave = async () => {
    const group = await dispatch(organizationStore.thunks.updateEntity()).unwrap()
    dispatch(organizationStore.actions.setActive(group))
    setIsDirty(false)
  }

  return (
    <>
      <PageHeader
        title={t("Barèmes & attributs")}
        subtitle={t(
          "Configurez les échelles de cotation des risques physiques et RPS, ainsi que les attributs de vos fiches de risque."
        )}
      />
      <RiskOrganizationScalesConfig riskType="phy" onDirty={() => setIsDirty(true)} />
      <RiskOrganizationScalesConfig riskType="rps" onDirty={() => setIsDirty(true)} />
      <RiskOrganizationAttributesConfig onDirty={() => setIsDirty(true)} />
      {/* <RiskOrganizationRpsImportConfig /> */}
      {isDirty && <SaveToast status={status as StatusType} onCancel={handleCancel} onSave={handleSave} isSaveActive />}
    </>
  )
}
